import { MDBRow, MDBCol, MDBIcon } from "mdbreact";

import locale from "locale";

const HomeServices = () => {
  return (
    <section className="text-center moz-p-home__services moz-p-home__section">
      <h2 className="my-5 font-weight-bold heading-secondary">
        {locale.SERVICES.OUR_SERVICES_QUESTION}
      </h2>
      <p className="paragraph--lead grey-text moz-p-home__services--answer">
        {locale.SERVICES.OUR_SERVICES_ANSWER}
      </p>
      <MDBRow>
        <MDBCol md="4">
          <MDBIcon icon="suitcase" size="3x" className="red-text" />
          <h3 className="font-weight-bold my-4 heading-tertiary">
            {locale.SERVICES.TRAVELS}
          </h3>
          <p className="grey-text mb-md-0 mb-5 paragraph">
            {locale.SERVICES.TRAVELS_DESCRIPTION}
          </p>
        </MDBCol>
        <MDBCol md="4">
          <MDBIcon icon="plane" size="3x" className="cyan-text" />
          <h3 className="font-weight-bold my-4 heading-tertiary">
            {locale.SERVICES.VISAS_AND_AIRLINE_TICKETS}
          </h3>
          <p className="grey-text mb-md-0 mb-5 paragraph">
            {locale.SERVICES.VISAS_AND_AIRLINE_TICKETS_DESC_1}
            <a
              href="/static/pdf/POTREBNA DOKUMENTA ZA VIZIRANJE ZA VELIKU BRITANIJU.pdf"
              download
              className="text-primary"
            >
              {locale.SERVICES.VISAS_AND_AIRLINE_TICKETS_DESC_2}
            </a>
            {locale.SERVICES.VISAS_AND_AIRLINE_TICKETS_DESC_3}
          </p>
        </MDBCol>
        <MDBCol md="4">
          <MDBIcon icon="medkit" size="3x" className="green-text" />
          <h3 className="font-weight-bold my-4 heading-tertiary">
            {locale.SERVICES.TRAVEL_INSURANCE}
          </h3>
          <p className="grey-text mb-md-0 mb-5 paragraph">
            {locale.SERVICES.TRAVEL_INSURANCE_DESCRIPTION}
          </p>
        </MDBCol>
      </MDBRow>
    </section>
  );
};

export default HomeServices;
